"use client";

import { c as _c } from "react/compiler-runtime";
import { getCollectionView, getContentViewKeyByValue } from "@/app/nextgen/collection/[collection]/page-utils";
import { useShallowRedirect } from "@/app/nextgen/collection/[collection]/useShallowRedirect";
import { useTitle } from "@/contexts/TitleContext";
import { NextGenCollection } from "@/entities/INextgen";
import { NextgenCollectionView } from "@/enums";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { formatNameForUrl } from "@/components/nextGen/nextgen_helpers";
import styles from "../NextGen.module.scss";
import NextGenNavigationHeader from "../NextGenNavigationHeader";
import NextGenCollectionArt from "./NextGenCollectionArt";
import NextGenCollectionArtist from "./NextGenCollectionArtist";
import NextGenCollectionDetails from "./NextGenCollectionDetails";
import NextGenCollectionHeader from "./NextGenCollectionHeader";
import NextGenCollectionSlideshow from "./NextGenCollectionSlideshow";
export function printViewButton(currentView: NextgenCollectionView, v: NextgenCollectionView, setView: (v: NextgenCollectionView) => void) {
  return <button onClick={() => setView(v)} className={`btn-link decoration-none ${v === currentView ? styles.nextgenTokenDetailsLinkSelected : ""}`}>
      <h4 className={v === currentView ? "font-color" : "font-color-h cursor-pointer"}>
        {v}
      </h4>
    </button>;
}
export default function NextGenCollectionComponent(t0) {
  const $ = _c(48);
  const {
    collection,
    initialView
  } = t0;
  useShallowRedirect(collection.name);
  const {
    setTitle
  } = useTitle();
  const [view, setView] = useState(initialView);
  let t1;
  let t2;
  if ($[0] !== collection.name || $[1] !== setTitle || $[2] !== view) {
    t1 = () => {
      const viewTitle = view !== NextgenCollectionView.OVERVIEW ? ` | ${view}` : "";
      setTitle(`${collection.name}${viewTitle} | NextGen`);
    };
    t2 = [collection.name, view, setTitle];
    $[0] = collection.name;
    $[1] = setTitle;
    $[2] = view;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== collection.name) {
    t3 = newView => {
      setView(newView);
      let path = newView === NextgenCollectionView.OVERVIEW ? "" : `/${getContentViewKeyByValue(newView).toLowerCase()}`;
      path = path.replaceAll(" ", "-").replaceAll("_", "-");
      const newPath = `/nextgen/collection/${formatNameForUrl(collection.name)}${path}`;
      window.history.pushState({
        view: newView
      }, "", newPath);
    };
    $[5] = collection.name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const updateView = t3;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const onPopState = e => {
        if (e.state?.view) {
          const newView_0 = getCollectionView(e.state.view);
          setView(newView_0);
        }
      };
      window.addEventListener("popstate", onPopState);
      return () => window.removeEventListener("popstate", onPopState);
    };
    t5 = [];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <NextGenNavigationHeader />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== collection) {
    t7 = collection.mint_count > 0 && <NextGenCollectionSlideshow collection={collection} />;
    $[10] = collection;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== collection) {
    t8 = <NextGenCollectionHeader collection={collection} show_links={true} />;
    $[12] = collection;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== updateView || $[15] !== view) {
    t9 = printViewButton(view, NextgenCollectionView.OVERVIEW, updateView);
    $[14] = updateView;
    $[15] = view;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== updateView || $[18] !== view) {
    t10 = printViewButton(view, NextgenCollectionView.ABOUT, updateView);
    $[17] = updateView;
    $[18] = view;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== updateView || $[21] !== view) {
    t11 = printViewButton(view, NextgenCollectionView.PROVENANCE, updateView);
    $[20] = updateView;
    $[21] = view;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== updateView || $[24] !== view) {
    t12 = printViewButton(view, NextgenCollectionView.TOP_TRAIT_SETS, updateView);
    $[23] = updateView;
    $[24] = view;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t9) {
    t13 = <Row className="pt-5"><Col className="d-flex gap-4">{t9}{t10}{t11}{t12}</Col></Row>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== collection || $[32] !== view) {
    t14 = <Row className="pt-3"><Col><NextGenCollectionDetails collection={collection} view={view} /></Col></Row>;
    $[31] = collection;
    $[32] = view;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== collection) {
    t15 = <Row className="pt-4"><Col><NextGenCollectionArt collection={collection} show_view_all={true} /></Col></Row>;
    $[34] = collection;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t8) {
    t16 = <Container className="pt-3 pb-2"><>{t8}{t13}{t14}{t15}</></Container>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t8;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Row><Col><h4>About the Artist</h4></Col></Row>;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== collection) {
    t18 = <Container className="pt-4 pb-4">{t17}<Row><Col><NextGenCollectionArtist collection={collection} /></Col></Row></Container>;
    $[42] = collection;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t16 || $[45] !== t18 || $[46] !== t7) {
    t19 = <>{t6}{t7}{t16}{t18}</>;
    $[44] = t16;
    $[45] = t18;
    $[46] = t7;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  return t19;
}